export enum EnumProjectModule {
  Leave = 'Leave',
  Expense = 'Expense',
  Forms = 'Forms',
  Documents = 'Documents',
  Shifts = 'Shifts',
}

enum ProjectStatus {
  active,
  Disabled,
}
export { ProjectStatus };
